import { ref } from 'vue';
import { log } from '@/utils/core/vueLogger.js';

// Reusable open/submit lifecycle for a v-dialog wrapping a v-stepper + v-form: tracks dialog
// visibility and wraps the save handler with isSaving guarding + error logging so it always
// resets, even on an early return. See DeliveryLocationForm.vue for a reference usage.
export function useStepperFormDialog(logContext) {
	const isOpen = ref(false);
	const isSaving = ref(false);

	function openDialog() {
		isOpen.value = true;
	}

	function closeDialog() {
		isOpen.value = false;
	}

	async function submit(handler) {
		if (isSaving.value) return;
		isSaving.value = true;
		try {
			await handler();
		} catch (error) {
			log('error', logContext, `❌ Save failed: ${error.message}`);
		} finally {
			isSaving.value = false;
		}
	}

	return { isOpen, isSaving, openDialog, closeDialog, submit };
}
